module.exports = __webpack_public_path__ + "img/menuimg4.8206c1de.png";